// src/config/payments.js

export const RAZORPAY = {
  keyId: "rzp_live_xxxxxxxxxx", // keep yours
  paymentLinks: {
    DAY_PASS:  "https://rzp.io/rzp/42cUFks",
    WEEK_PASS: "https://rzp.io/rzp/jfb5UvEI",
    // (No Annual link used anymore)
    // MONTHLY: "https://rzp.io/rzp/<your-monthly-link>", // future
  },
};

export const PLANS = {
  DAY_PASS: {
    id: "day_inr",
    amount: 9900, // paise (₹99)
    currency: "INR",
    description: "Treble Town — Day Pass (24h)",
    tenureDays: 1,
    linkKey: "DAY_PASS",
    enabled: true,
  },
  WEEK_PASS: {
    id: "week_inr",
    amount: 19900, // ₹199
    currency: "INR",
    description: "Treble Town — 7-Day Pass",
    tenureDays: 7,
    linkKey: "WEEK_PASS",
    enabled: true,
  },

  // Replace Annual with a non-clickable placeholder
  MONTHLY_INR: {
    id: "monthly_inr",
    amount: null,                 // no price shown
    currency: "INR",
    description: "Treble Town — Monthly (Coming Soon)",
    tenureDays: 30,
    linkKey: null,                // no link
    enabled: false,               // not purchasable
    comingSoon: true,             // UI hint
    displayLabel: "Monthly — Coming Soon",
  },
};

// ------- helpers -------
export const ENABLED_PLAN_IDS = Object.values(PLANS)
  .filter((p) => p.enabled)
  .map((p) => p.id);

export const ENABLED_PLANS = Object.fromEntries(
  Object.entries(PLANS).filter(([, p]) => p.enabled)
);

export const COMING_SOON_PLANS = Object.fromEntries(
  Object.entries(PLANS).filter(([, p]) => p.comingSoon)
);

export const getPlanById = (id) =>
  Object.values(PLANS).find((p) => p.id === id);

export const isPlanEnabled = (planOrId) => {
  const id = typeof planOrId === "string" ? planOrId : planOrId?.id;
  return ENABLED_PLAN_IDS.includes(id);
};

export const isComingSoon = (planOrId) => {
  const p = typeof planOrId === "string" ? getPlanById(planOrId) : planOrId;
  return !!p?.comingSoon;
};
